import {create, path, alias, expr, middleware, incomplete, validate, Closure, index, createMany} from '@acng/frontend-voyager';
import {replaceUrl} from '@acng/frontend-relativity/history';
import {guard, IS} from '@acng/frontend-rubicon';

import {Amateur} from '../../amateurPool/model/amateur.js';
import {PictureSet} from '../model/picture-set';
import {PicturesVisit} from '../../Lib/Log/events/visit';
import {logger} from '../../Lib/Log/client';
import {authUser} from '../../userPool/context/auth-user';
import {main} from '../../core/service/location.js';
import {mainView, stickyView} from 'acng/layout/service/sequence.js';
import {onlyUserOrPreview} from 'acng/userPool/config/middleware';
import {amateurRoute} from 'acng/amateurPool/config/routes';
import {inject} from 'acng/core/service/ng';
import {picturePoolFeature} from './feature';
import {LocalActor} from '@acng/frontend-relativity';
import {ctxGallery} from 'acng/core/context/gallery.js';
import {documentElement} from '@acng/frontend-bounty/dom/document.js';

main.create(
  onlyUserOrPreview,
  incomplete,
  expr(/^(?:\/sedcard\/.+)?\/pictures\/sets/y), //
  // TODO alias is required by onswCategorySelect in sidebar
  alias('pictureSets'),
  createMany(
    [
      index,
      mainView(picturePoolFeature, 'pictureSets'),
    ],
    [
      path('/{type}'),
      validate(({type}) => /^(top|new|classics)$/.test(/** @type {string} */ (type))),
      stickyView(picturePoolFeature, 'list-header'),
      mainView(picturePoolFeature, 'pictureSets'),
    ],
  ),
);

amateurRoute.create(
  path('/pictures/sets'),
  Closure((params) => {
    if (!authUser) {
      return;
    }

    const {amateur} = params;
    ASSERT: guard(amateur, IS(Amateur));

    const laforgeEvent = new PicturesVisit(authUser.uid, amateur);

    return () => logger.send(laforgeEvent.endVisit());
  }),
);

const providePictureSet = LocalActor(ctxGallery);

amateurRoute.create(
  path('/pictures/set/{setId}'),
  mainView(picturePoolFeature, 'pictureSet'),
  middleware((next, prev) => {
    if (next.setId == prev.setId) {
      next.set = prev.set;
      return true;
    }
    const PictureSet = inject('PictureSet');
    return PictureSet.get(/** @type {string} */ (next.setId))
      .then((pictureSet) => {
        next.set = pictureSet;
      })
      .catch((reason) => {
        replaceUrl('/#/');
        throw reason;
      });
  }),
  Closure(({set}) => {
    ASSERT: guard(set, IS(PictureSet));
    const unlock = providePictureSet(documentElement, set);

    return () => unlock(documentElement);
  }),
  create(
    path('/item'),
    incomplete,
    alias('pictureSlideshow'),
    create(path('/{item}'), alias('pictureSlideshowImage'))
  )
);
